const state = {
    openResult: {
        opened: null,
        openedTs: null,
        expiredTs: null,
        enabledCode: '',
        enabledStatus: null,
        fleetCode: '',
        carNo: '',
        openedUser: '',
        openedMobile: '' ,
        productName:''   
    }
};

export default state;
